import styled from 'styled-components';

export const Container = styled.div`
  .clean-cart-modal,
  .delete-product-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    max-width: 30rem;
    height: 100%;
    min-height: 16rem;
    gap: 3rem;
  }

  .clean-cart-modal span,
  .delete-product-modal span {
    color: var(--primary_color);
    font-size: 1.2rem;
    font-weight: 700;
  }

  .clean-cart-modal .delete-product-buttons,
  .delete-product-modal .delete-product-buttons {
    display: flex;
    gap: 1rem;
  }

  .progressive-discount-group {
    position: relative;
    width: max-content;

    .progressive-discount-tag {
      display: flex;
      flex-direction: column;
      gap: 0.05rem;
      margin: 1rem 0;
    }

    .progressive-selo {
      width: 11rem;
      margin-bottom: 0.1rem;
    }

    .progressive-discount-tag span {
      text-align: center;
      width: 11rem;
      padding: 0.4rem 1rem;
      font-size: 0.8rem;
      font-weight: 700;
      color: var(--white);
      border-radius: 0.4rem;
      user-select: none;
      background: var(--gradient_green);
    }

    .progressive-discount-tag span:last-child {
      background: var(--blue_light);
    }

    .progressive-discount-info {
      display: none;
      position: absolute;
      top: 50%;
      right: -2rem;
      transform: translate(100%, -50%);
      background: var(--primary_color);
      border-radius: 0.7rem;
      padding: 10px;
      color: var(--white);
      font-size: 0.6rem;
      font-weight: 700;
    }

    .progressive-discount-info::before {
      content: '';
      position: absolute;
      background-color: var(--primary_color);
      top: 50%;
      left: 0;
      transform: translate(-82%, -50%);
      clip-path: polygon(100% 0, 0% 50%, 100% 100%);
      height: calc(100% - 0.3rem);
      width: 1.5rem;
    }

    &:hover {
      .progressive-discount-info {
        display: block;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 0.4rem;

  > div {
    display: flex;
    width: 100%;
  }

  .product-item-image {
    width: 5rem !important;
    height: 5rem !important;
  }

  span {
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--gray);
  }

  .info {
    width: 100%;

    .product-name {
      margin-bottom: 1rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow-y: hidden;
    }

    .price-and-quantity {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .product-item-mini-cart-price-info
        .product-item-mini-cart-old-price-info {
        display: flex;
        align-items: center;
        font-size: 0.9rem;
        font-weight: 500;
        color: var(--gray_intermediary);

        .product-item-mini-cart-old-price {
          position: relative;
          margin-left: 0.4rem;
          font-size: 0.9rem;
          font-weight: 500;
          color: var(--gray_intermediary);
        }
      }

      .product-item-mini-cart-price-for-info .product-item-mini-cart-price-for {
        font-size: 1.25rem;
        font-weight: 800;
        color: var(--primary_color);
      }

      .item-counter {
        max-width: 10rem;
        min-height: 2.2rem;

        button {
          font-size: 0.8rem;
          max-width: 1.6rem;
          padding: 0 0.3rem;
        }

        input {
          font-size: 0.8rem;
          max-width: 2rem;
        }
      }
    }
  }

  .icon {
    width: 1.4rem;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    .info .price-and-quantity .item-counter button {
      font-size: 1rem;
    }
  }

  @media (max-width: 400px) {
    .info .price-and-quantity .item-counter {
      width: 100%;
      max-width: 5rem;

      button {
        font-size: 0.7rem;
        font-weight: 500;
        padding: 0;
        width: 100%;
      }

      input {
        max-width: 1.1rem;
      }
    }
  }
`;
